var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        { staticClass: "menu-wrapper cargo-siderbar" },
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? _c(
                "div",
                {
                  attrs: { draggable: "true" },
                  on: {
                    dragstart: function($event) {
                      _vm.onDragStart($event, {
                        item: _vm.onlyOneChild || _vm.item,
                        icon:
                          _vm.onlyOneChild.meta.icon ||
                          (_vm.item.meta && _vm.item.meta.icon),
                        title: _vm.onlyOneChild.meta.title,
                        enTitle: _vm.onlyOneChild.meta.enTitle,
                        jaTitle: _vm.onlyOneChild.meta.jaTitle,
                        ruTitle: _vm.onlyOneChild.meta.ruTitle,
                        thTitle: _vm.onlyOneChild.meta.thTitle,
                        viTitle: _vm.onlyOneChild.meta.viTitle
                      })
                    }
                  }
                },
                [
                  _vm.onlyOneChild.meta
                    ? _c(
                        "app-link",
                        {
                          attrs: {
                            id: "SidebarItem" + _vm.item.menuId,
                            to: _vm.item.root
                              ? ""
                              : _vm.resolveRealPath(_vm.onlyOneChild)
                          }
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              class: {
                                "submenu-title-noDropdown": !_vm.isNest
                              },
                              attrs: {
                                index:
                                  _vm.resolvePath(_vm.onlyOneChild.path) +
                                  _vm.item.menuId
                              },
                              on: {
                                click: function($event) {
                                  return _vm.clickMenu(_vm.item)
                                }
                              }
                            },
                            [
                              _c("item", {
                                attrs: {
                                  icon:
                                    _vm.onlyOneChild.meta.icon ||
                                    (_vm.item.meta && _vm.item.meta.icon),
                                  title: _vm.getLangMetaTitle(_vm.item.meta)
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  class: _vm.getClass(_vm.item),
                  attrs: {
                    id: "SidebarItem" + _vm.item.menuId,
                    index: _vm.item.menuId + "",
                    "popper-append-to-body": ""
                  },
                  nativeOn: {
                    mouseenter: function($event) {
                      return (function() {
                        return _vm.handleMouseenter(_vm.item.menuId)
                      })($event)
                    }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item.meta
                        ? _c("item", {
                            attrs: {
                              icon: _vm.item.meta.icon,
                              title: _vm.getLangMetaTitle(_vm.item.meta)
                            }
                          })
                        : _vm._e(),
                      _vm.item.path === "/ApprovalMatters" &&
                      !!_vm.item.badgeCount
                        ? _c("el-badge", {
                            staticClass: "item",
                            attrs: { value: _vm.item.badgeCount }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  (_vm.item.meta && _vm.item.meta.title) === "统计分析" &&
                  _vm.starSchema
                    ? _c(
                        "div",
                        {
                          staticClass: "menu-wrapper cargo-siderbar nest-menu"
                        },
                        [
                          _vm._l(_vm.starSchema, function(child) {
                            return _c(
                              "app-link",
                              {
                                key: child.id,
                                attrs: {
                                  id: "SidebarItem" + child.id,
                                  to: _vm.getAnalysisPath(
                                    child,
                                    _vm.item,
                                    _vm.dwReportShowMode,
                                    _vm.currentOfficeUuid
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { index: child.id },
                                    on: { click: _vm.clickMenu }
                                  },
                                  [
                                    _c("item", {
                                      attrs: {
                                        title: _vm.getReportMenuName(child)
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._l(_vm.statReportChildren, function(
                            child,
                            index
                          ) {
                            return _c(
                              "app-link",
                              {
                                key: (child.path || "") + index,
                                attrs: {
                                  id: "SidebarItem" + child.menuId,
                                  to: _vm.resolvePath(child.path)
                                }
                              },
                              [
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      index:
                                        _vm.resolvePath(child.path) +
                                        (child.menuId || index)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickMenu(child)
                                      }
                                    }
                                  },
                                  [
                                    _c("item", {
                                      attrs: {
                                        title: _vm.getLangMetaTitle(child.meta)
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm.canRendItem
                    ? _vm._l(_vm.item.children, function(child, index) {
                        return _c("sidebar-item", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: child.name !== "AutomaticReconciliation",
                              expression:
                                "child.name !== 'AutomaticReconciliation'"
                            }
                          ],
                          key: child.path + index,
                          staticClass: "nest-menu",
                          attrs: {
                            "is-nest": true,
                            item: child,
                            "base-path": _vm.resolvePath(child.path)
                          }
                        })
                      })
                    : _vm._e()
                ],
                2
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }